<template>
  <v-container fluid no-gutters class="my-0 py-0">
    <v-row justify="center" align="center">
      <v-col cols=12 justify="center" align="center" class="mx-0 my-0 px-0 py-0">
        <v-img
            class="white--text align-end"
            height="auto"
            width="100vw"
            contain
            :src="require('@/assets/PARON-CARD.jpg')"
        />
      </v-col>
    </v-row>
    <div class="about-content" v-html="renderedAbout"></div>
  </v-container>
</template>


<script>
  import pages from "@/services/pages"

  export default {
    data() {
        return {
            about: null
        }
    },
    computed: {
      renderedAbout() {
        if (!this.about) {
          return ''
        }
        return this.normalizeRichText(this.about)
      },
    },
    created() {
        this.fetchAbout()
    },
    methods: {
      getImage() {
        return require('@/assets/LOGOPARON 2023.png')
        
      },
      fetchAbout() {
        pages.getAbout()
          .then(response => {
            this.about = response.data[0].description
          })
          .catch(error => {
            console.log(error)
          })
      },
      normalizeRichText(value) {
        let html = (value || '').toString().trim()

        // Remove markdown code fences if content was pasted from chat/code blocks.
        html = html.replace(/^```(?:html)?\s*/i, '').replace(/\s*```$/, '')

        // Decode escaped HTML entities, e.g. &lt;div&gt;...&lt;/div&gt;
        if (html.includes('&lt;') || html.includes('&gt;') || html.includes('&amp;')) {
          const decoder = document.createElement('textarea')
          decoder.innerHTML = html
          html = decoder.value
        }

        return html
      },
    }
  }
</script>

<style lang="scss" scoped>
    ::v-deep .about-content {
      color: #1b2f5a;
      font-size: 16px;
      line-height: 1.7;
      max-width: 1100px;
      margin: 0 auto;
      padding: 0 16px;
    }

    ::v-deep .about-content a {
      color: #1b2f5a;
    }

    ::v-deep .about-content img {
      max-width: 100%;
      height: auto;
      display: block;
      margin: 0 auto;
    }

    ::v-deep .about-content p,
    ::v-deep .about-content li,
    ::v-deep .about-content div {
      color: #1b2f5a;
    }

    ::v-deep .about-content p {
      margin: 0 0 12px;
    }

    ::v-deep .about-content h1,
    ::v-deep .about-content h2,
    ::v-deep .about-content h3,
    ::v-deep .about-content h4 {
      color: #1b2f5a;
      margin: 20px 0 12px;
      line-height: 1.3;
    }

    ::v-deep .about-content ul,
    ::v-deep .about-content ol {
      padding-left: 20px;
      margin: 8px 0 16px;
    }

    ::v-deep .about-content [style*="display:flex"] {
      gap: 20px;
    }

    @media only screen and (max-width: 960px) {
      ::v-deep .about-content [style*="display:flex"] {
        display: block !important;
      }
    }

    .custom-title{
        font-weight:bold;
        font-size: 20px!important;
        color: #1b2f5a;
    }
    .custom-text{
        font-size: 16px!important;
        color: #1b2f5a;
    }

    .theme--light.v-divider {
        border-color: rgb(0 0 0);
    }

    .v-divider--vertical {
      border-width: 300px thin 100px 0;
  }
</style>